export enum LayoutType {
	Fit,
	Stretch,
	OverflowX,
	OverflowY
}
